// extracted by mini-css-extract-plugin
export default {"toggleBtn":"PointList_toggleBtn__fZ2Gb","multiSwitchWrapper":"PointList_multiSwitchWrapper__srKUG"};